// extracted by mini-css-extract-plugin
export var container = "_s5-0";
export var table = "_s5-2";
export var tableWrapper = "_s5-1";